import { css } from '@emotion/react'
import { ExternalStyles, Theme, useTheme } from 'bold-ui'

interface DividerProps {
  style?: ExternalStyles
}

export const Divider = ({ style }: Readonly<DividerProps>) => {
  const theme = useTheme()
  const styles = createStyles(theme)
  return <hr css={[styles.divider, style]} />
}

const createStyles = (theme: Theme) => ({
  divider: css`
    margin: 0;
    background: ${theme.pallete.divider};
  `,
})
